require('./polyfills')

const { Syncer } = require('#utils/syncer')

/* eslint-disable no-undef */
function onload(callback) {
  /* node:coverage disable */
  if (typeof window !== 'undefined') {
    window.document.addEventListener('DOMContentLoaded', () => callback(window))
  }
  /* node:coverage enable */
}
/* eslint-enable no-undef */

function App($window, $location = $window.location, $document = $window.document) {
  const config = $window.__gaw__.c
  const track = $window.__gaw__.t
  delete $window.__gaw__
  // document.documentElement is the root HTML element
  const { sync } = new Syncer($document.documentElement)
  let state = null
  return Object.freeze({
    $window,
    $location,
    config,
    get state() { return state },
    set state(x) {
      state = x
      sync(state)
    },
    sync,
    track,
  })
}
App.init = (PageConstructor) => {
  const init = (...args) => {
    const app = new App(...args)
    app.state = PageConstructor(app)
    // Setting app on window is just handy for debugging, not actually necessary.
    // I should probably not do this in production.
    app.$window.app = app
    // Likewise for returning app. Just handy for tests to get a reference.
    return app
  }
  onload(init)
  return init
}

exports.App = App
